import {PdvModel} from "../../Models/PdvModel";
import {door1PdvsMock} from "./door1Pdvsock";

const pdvMock = new Map<string, PdvModel[]>()

pdvMock.set("1", door1PdvsMock)
pdvMock.set("2", [])

export {pdvMock}

